import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import SelectIcon from '@material-ui/icons/Check';
import SelectedIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {}
}));

const NavSelectable = ({
  selected = false,
  onClick
}) => {
  const classes = useStyles();

  if (selected) {
    return React.createElement(IconButton, {
      className: classes.root,
      color: "inherit",
      "aria-label": "select",
      onClick: onClick
    }, React.createElement(SelectedIcon, null));
  }

  return React.createElement(IconButton, {
    className: classes.root,
    color: "inherit",
    "aria-label": "select",
    onClick: onClick
  }, React.createElement(SelectIcon, null));
};

export default NavSelectable;